import { ExternalLink } from "lucide-react";

interface AppleBooksLinkProps {
  appleLink: string;
  title: string;
  className?: string;
}

const AppleBooksLink = ({ appleLink, title, className = "" }: AppleBooksLinkProps) => {
  if (!appleLink) return null;

  const handleClick = () => {
    // If appleLink is just a numeric trackId, convert to full URL
    const url = /^\d+$/.test(appleLink) 
      ? `https://books.apple.com/gb/book/id${appleLink}`
      : appleLink;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center justify-center px-2 py-1 bg-transparent border border-[rgba(255,255,255,0.1)] text-slate-400 text-xs rounded-md transition-all duration-300 ease-in-out hover:border-slate-300 hover:text-slate-200 ${className}`}
      title={`View "${title}" in Apple Books`}
      aria-label={`View ${title} in Apple Books`}
    >
      <svg className="w-3 h-3 mr-1.5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
      </svg>
      <span className="text-[10px]">Apple</span>
    </button>
  );
};

export default AppleBooksLink;
